export default __webpack_public_path__ + "static/media/CNo.71-3.e6136c8f.jpg";